<template>
  <div id='bd-main'>
    <flow-panel></flow-panel>
  </div>
</template>

<script>
// import { mapGetters, mapActions } from 'vuex'
import FlowPanel from '@/plugins/easyflow/panel'
import '@/plugins/easyflow/index.css'

export default {
  name: 'bd-main',
  components: { FlowPanel },
  data () {
    return {
      resize: true
    }
  },
  computed: {
    // ...mapGetters([ 'leaveMessages' ])
  },
  methods: {
    // ...mapActions([ 'getLeaveMessages' ]),
    // handleCurrentChange(val) {
    //   console.log(`当前页: ${val}`);
    //   let payload = { page: val - 1, size: 10 }
    // this.getLeaveMessages(payload)
    // }
  },
  created() {
    // let payload = { page: 0, size: 10 }
    // this.getLeaveMessages(payload)
  },

}
</script>

<style scoped>
#bd-main {
  text-align: left;
}
</style>
